/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GmailThreadPreview } from './GmailThreadPreview';
import {
    GmailThreadPreviewFromJSON,
    GmailThreadPreviewFromJSONTyped,
    GmailThreadPreviewToJSON,
    GmailThreadPreviewToJSONTyped,
} from './GmailThreadPreview';

/**
 * Response from searching Gmail threads
 * @export
 * @interface SearchGmailThreadsResponse
 */
export interface SearchGmailThreadsResponse {
    /**
     * 
     * @type {Array<GmailThreadPreview>}
     * @memberof SearchGmailThreadsResponse
     */
    threads: Array<GmailThreadPreview>;
    /**
     * Total estimated results
     * @type {number}
     * @memberof SearchGmailThreadsResponse
     */
    resultSizeEstimate: number;
    /**
     * Token for fetching next page of results
     * @type {string}
     * @memberof SearchGmailThreadsResponse
     */
    nextPageToken?: string;
}

/**
 * Check if a given object implements the SearchGmailThreadsResponse interface.
 */
export function instanceOfSearchGmailThreadsResponse(value: object): value is SearchGmailThreadsResponse {
    if (!('threads' in value) || value['threads'] === undefined) return false;
    if (!('resultSizeEstimate' in value) || value['resultSizeEstimate'] === undefined) return false;
    return true;
}

export function SearchGmailThreadsResponseFromJSON(json: any): SearchGmailThreadsResponse {
    return SearchGmailThreadsResponseFromJSONTyped(json, false);
}

export function SearchGmailThreadsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGmailThreadsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'threads': ((json['threads'] as Array<any>).map(GmailThreadPreviewFromJSON)),
        'resultSizeEstimate': json['resultSizeEstimate'],
        'nextPageToken': json['nextPageToken'] == null ? undefined : json['nextPageToken'],
    };
}

export function SearchGmailThreadsResponseToJSON(json: any): SearchGmailThreadsResponse {
    return SearchGmailThreadsResponseToJSONTyped(json, false);
}

export function SearchGmailThreadsResponseToJSONTyped(value?: SearchGmailThreadsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threads': ((value['threads'] as Array<any>).map(GmailThreadPreviewToJSON)),
        'resultSizeEstimate': value['resultSizeEstimate'],
        'nextPageToken': value['nextPageToken'],
    };
}

